<template>
    <club-dashboard v-if="$store.getters.getConfig('user').club_id !== undefined && $store.getters.getConfig('user').organization_id !== undefined" :club_slug="$store.getters.getConfig('user').club_slug"></club-dashboard>
    <fachstellen-dashboard v-else-if="$store.getters.getConfig('user').fachstellen_id !== undefined && $store.getters.getConfig('user').organization_id !== undefined" :fachstellen_slug="$store.getters.getConfig('user').fachstellen_slug"></fachstellen-dashboard>
    <organization-dashboard v-else-if="$store.getters.getConfig('user').organization_id !== undefined" :organization_slug="$store.getters.getConfig('user').organization_slug"></organization-dashboard>
    <dashboard v-else></dashboard>
</template>
<script>
    import Dashboard from './Dashboard'
    import ClubDashboard from '@/components/Layout/Clubs/Dashboard'
    import FachstellenDashboard from '@/components/Layout/Fachstellen/Dashboard'
    import OrganizationDashboard from '@/components/Layout/Organizations/Dashboard'
    export default {
        components: {
            "dashboard": Dashboard,
            "club-dashboard": ClubDashboard,
            "fachstellen-dashboard": FachstellenDashboard,
            "organization-dashboard": OrganizationDashboard,
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Dashboard/Index.vue